/**
 * @generated SignedSource<<448b0835064b6dce395ccb66232cba0f>>
 * @relayHash 0b8180915d5e2f2085ea46a67dcf5010
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a51e93297bdfd259d7384f2fea83857a11e1a1b862e2512419df604d05571216

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a51e93297bdfd259d7384f2fea83857a11e1a1b862e2512419df604d05571216",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider
    }
  }
};

export default node;
